// extracted by mini-css-extract-plugin
export default {"mainwrapper":"left_mainwrapper__tKNFl","leftwrapper":"left_leftwrapper__d085c","offers":"left_offers__wLMlG","circle":"left_circle__F+t4Q","first":"left_first__E-gHd"};